module.exports = __webpack_public_path__ + "static/mercy-me.5a49c8ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/people/mercy-me.jpg
// module id = 1315
// module chunks = 168707334958949